import { Garantie } from "./garantie";

export class Pret {

  public capitalRestant: number;
  public dureeRestanteMois: number;
  public dateSignatureOffre: string;
  public taux: number;
  public typePret: any;
  public lieuAchat: any;
  public usageBien: any;
  public etablissementBancaire: any;
  public caisseFiliale: any;
  public garantie: string;
  public garanties: Garantie[];
  public dateEffective: string;
}



// WEBPACK FOOTER //
// ./src/app/pret.ts